/** Theme-vibe prompts used by the "I'm feeling lucky" buttons (admin
 * theme dialog + buyer setup wizard). */
export const THEME_WORDS = [
  "blush pink and gold, soft and romantic garden wedding",
  "modern minimalist, clean ivory and charcoal",
  "vintage and classic, warm cream and burgundy",
  "rustic garden wedding, sage green and terracotta",
  "moody and dramatic, deep navy and dusty rose",
  "bohemian, warm terracotta and mustard",
  "midnight elegance, deep plum and champagne gold",
  "spring blossom, lilac and fresh mint",
];

/** A random vibe for the "I'm feeling lucky" button. */
export function randomThemeWord(): string {
  return (
    THEME_WORDS[Math.floor(Math.random() * THEME_WORDS.length)] ??
    "romantic and elegant"
  );
}
